// Tracks which SSO provider authenticated the current standalone (non-iframe)
// session, so a deep link carrying `auto_login_sso_provider_id` can reuse the
// session when the provider matches and force a logout + re-login when it
// differs. The session's provider is not derivable from server data, so we
// record it ourselves at sign-in.
//
// - `sso_session_provider` (localStorage): provider id of the current session.
// - `pending_sso_session_provider` (sessionStorage, tab-scoped): set right before
//   the SSO redirect and promoted on sign-in. Because the provider is stripped
//   from the OAuth redirect_url, this carries it across the redirect round-trip
//   within the same tab without leaking across tabs.

const SESSION_PROVIDER_KEY = 'sso_session_provider';
const PENDING_PROVIDER_KEY = 'pending_sso_session_provider';

export const setPendingSsoProvider = (providerId: string): void =>
  sessionStorage.setItem(PENDING_PROVIDER_KEY, providerId);

export const clearPendingSsoProvider = (): void =>
  sessionStorage.removeItem(PENDING_PROVIDER_KEY);

export const getSsoSessionProviderId = (): string | null =>
  localStorage.getItem(SESSION_PROVIDER_KEY);

// Clear both the recorded session provider and any pending value. Called on
// logout and on organization/membership switch.
export const clearSsoSessionProvider = (): void => {
  localStorage.removeItem(SESSION_PROVIDER_KEY);
  sessionStorage.removeItem(PENDING_PROVIDER_KEY);
};

// Promote a pending provider to the session provider after a successful sign-in.
// No-op when there is no pending value (classic login, membership switch).
export const promotePendingSsoProvider = (): void => {
  const pending = sessionStorage.getItem(PENDING_PROVIDER_KEY);

  if (pending) {
    localStorage.setItem(SESSION_PROVIDER_KEY, pending);
    sessionStorage.removeItem(PENDING_PROVIDER_KEY);
  }
};
